/* Attua – busca do cabeçalho: painel no topo com categorias, produtos, busca por medida, mais buscados e buscas recentes. */
(function () {
  if (window.AttuaSearch) return;

  /* ---------- texto ---------- */
  function norm(s) { return String(s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/[^a-z0-9,.\s-]/g, ' ').replace(/\s+/g, ' ').trim(); }
  var STOP = { de: 1, da: 1, do: 1, das: 1, dos: 1, com: 1, para: 1, pra: 1, e: 1, a: 1, o: 1, as: 1, os: 1, em: 1, um: 1, uma: 1, no: 1, na: 1, p: 1, cm: 1, m: 1, metro: 1, metros: 1, lugares: 1, lugar: 1, x: 1 };
  /* sinônimos: cada palavra digitada vale por qualquer uma da lista */
  var SYN = {
    aparador: ['aparador', 'buffet', 'bufe'], buffet: ['buffet', 'aparador'], bufe: ['buffet', 'aparador'],
    pufe: ['puff', 'pufe'], puf: ['puff', 'pufe'], puff: ['puff', 'pufe'], puffs: ['puff'], pufes: ['puff'],
    banco: ['banco', 'banqueta'], bancos: ['banco', 'banqueta'], banqueta: ['banqueta', 'banco'], banquetas: ['banqueta', 'banco'],
    sofa: ['sofa'], sofas: ['sofa'], estofado: ['sofa', 'estofad'], estofados: ['sofa', 'estofad'],
    poltrona: ['poltrona'], poltronas: ['poltrona'], cadeira: ['cadeira'], cadeiras: ['cadeira'], mesa: ['mesa'], mesas: ['mesa'],
    diva: ['chaise', 'diva'], espreguicadeira: ['chaise'], recamier: ['recamier', 'banco'],
    criado: ['cabeceira'], 'criado-mudo': ['cabeceira'], mudo: ['cabeceira'], cabeceira: ['cabeceira'],
    reclinavel: ['retratil', 'reclinavel'], retratil: ['retratil'], retrateis: ['retratil'],
    curvo: ['organic', 'curvo'], curva: ['organic', 'curv'], organico: ['organic'], organica: ['organic'], organicos: ['organic'],
    giratoria: ['girat'], giratorias: ['girat'], giratorio: ['girat'],
    escritorio: ['escritorio', 'office'], office: ['office', 'escritorio'],
    externa: ['externa', 'outdoor'], externo: ['externa', 'outdoor'], varanda: ['externa', 'outdoor'], piscina: ['externa', 'outdoor'], jardim: ['externa', 'outdoor'], outdoor: ['outdoor', 'externa'],
    redonda: ['redond'], redondo: ['redond'], oval: ['oval'],
    apoio: ['lateral', 'apoio'], lateral: ['lateral'], laterais: ['lateral'], centro: ['centro'], jantar: ['jantar'],
    cama: ['cama'], camas: ['cama'], bar: ['bar'], carrinho: ['carrinho'], luminaria: ['luminaria'], abajur: ['luminaria', 'abajur'],
    canto: ['canto'], ilha: ['ilha'], chaise: ['chaise'], capa: ['capa'], eletrico: ['eletric'], modular: ['modular']
  };

  /* ---------- categorias (atalhos) ---------- */
  var CATS = [
    ['Sofás', '/collections/sofas', 'sofa sofas estofado'], ['Sofás de canto', '/collections/sofa-de-canto', 'sofa canto l'],
    ['Sofás com chaise', '/collections/sofa-com-chaise', 'sofa chaise'], ['Sofás retráteis', '/collections/sofa-retratil', 'sofa retratil reclinavel'],
    ['Sofás orgânicos', '/collections/sofa-organico', 'sofa organico curvo redondo'], ['Sofás ilha', '/collections/sofa-ilha', 'sofa ilha'],
    ['Sofás de capa', '/collections/sofa-de-capa', 'sofa capa'], ['Sofás elétricos', '/collections/sofa-eletrico', 'sofa eletrico'],
    ['Poltronas', '/collections/poltronas', 'poltrona poltronas'], ['Poltronas giratórias', '/collections/poltronas-giratorias', 'poltrona giratoria'],
    ['Poltronas com puff', '/collections/poltrona-com-puff', 'poltrona puff pufe'], ['Chaise longue', '/collections/chaise-longue', 'chaise diva espreguicadeira'],
    ['Mesas de jantar', '/collections/mesas-de-jantar', 'mesa jantar'], ['Mesas de jantar orgânicas', '/collections/mesa-de-jantar-organica', 'mesa jantar organica curva'],
    ['Mesas de centro', '/collections/mesas-de-centro', 'mesa centro'], ['Mesas laterais', '/collections/mesas-laterais', 'mesa lateral apoio'],
    ['Cadeiras de jantar', '/collections/cadeiras-de-jantar', 'cadeira cadeiras jantar'], ['Cadeiras de escritório', '/collections/cadeiras-de-escritorio', 'cadeira escritorio office'],
    ['Banquetas', '/collections/banquetas', 'banqueta banco bancada bar'], ['Camas', '/collections/cama', 'cama camas cabeceira'],
    ['Mesas de cabeceira', '/collections/mesas-de-cabeceira', 'mesa cabeceira criado mudo'], ['Carrinhos bar', '/collections/carrinho-bar', 'carrinho bar aparador'],
    ['Puffs', '/collections/puffs', 'puff pufe'], ['Área externa', '/collections/area-externa', 'externa externo varanda piscina jardim outdoor'],
    ['Consultório', '/collections/consultorio-escritorio', 'consultorio clinica recepcao escritorio'], ['Sale de Primavera', '/collections/sale-de-primavera', 'sale promocao desconto oferta'],
    ['Outlet', '/collections/outlet-attua', 'outlet promocao oferta'], ['Pronta entrega', '/collections/pronta-entrega', 'pronta entrega imediata']
  ].map(function (c) { return { n: c[0], u: c[1], k: norm(c[0] + ' ' + c[2]).split(' ') }; });

  var POPULAR = ['Sofá de canto', 'Sofá retrátil', 'Sofá orgânico', 'Poltrona giratória', 'Mesa de jantar', 'Cadeira de jantar'];
  var MAIN = [['Sofás', '/collections/sofas'], ['Poltronas', '/collections/poltronas'], ['Mesas de jantar', '/collections/mesas-de-jantar'], ['Cadeiras', '/collections/cadeiras-de-jantar'], ['Mesas de centro', '/collections/mesas-de-centro'], ['Banquetas', '/collections/banquetas']];

  /* ---------- tipos e medidas ---------- */
  var TYPES = [['sofas', /^sofa/], ['poltronas', /^(poltrona|chaise)/], ['cadeiras', /^cadeira/], ['banquetas', /^(banqueta|banco)/], ['mesas-jantar', /^mesa/]];
  var TYPE_NAME = { sofas: 'Sofás', poltronas: 'Poltronas', cadeiras: 'Cadeiras', 'mesas-jantar': 'Mesas de jantar' };
  var SIZEV = { sofas: [160, 180, 200, 220, 240, 260, 280, 300, 320, 350, 380, 400, 450], 'mesas-jantar': [140, 160, 180, 200, 220, 240, 260, 280] };
  var RANGES = { poltronas: [[0, 70], [71, 80], [81, 90], [91, 9999]], cadeiras: [[0, 50], [51, 55], [56, 60], [61, 9999]] };
  function fm(cm) { return cm >= 100 ? (cm / 100).toFixed(2).replace('.', ',') + ' m' : cm + ' cm'; }

  function parse(q) {
    var n = norm(q), measure = 0, mStr = '';
    var mm = n.match(/(\d+[.,]\d+)\s*(m|metros?)?\b/) || n.match(/\b(\d)\s*(m|metros?)\b/) || n.match(/\b(\d{2,3})\s*(cm|m)?\b/);
    if (mm) {
      var v = parseFloat(mm[1].replace(',', '.')), u = mm[2] || '';
      if (u === 'm' || /metro/.test(u) || v < 10) v = v * 100;
      v = Math.round(v);
      if (v >= 30 && v <= 600) { measure = v; mStr = mm[0]; }
    }
    var rest = mStr ? n.replace(mStr, ' ') : n;
    var tokens = rest.split(/[\s,.-]+/).filter(function (t) { return t && !STOP[t] && !/^\d+$/.test(t); });
    var tipo = '';
    if (/mesa(s)? de jantar|mesa jantar/.test(n)) tipo = 'mesas-jantar';
    else for (var i = 0; i < tokens.length && !tipo; i++) for (var j = 0; j < TYPES.length; j++) if (TYPES[j][1].test(tokens[i])) { tipo = TYPES[j][0]; break; }
    if (tipo === 'mesas-jantar' && !/jantar/.test(n)) tipo = '';
    if (measure && !tipo && measure >= 150) tipo = 'sofas';
    var medidaParam = 0;
    if (measure && tipo) {
      if (SIZEV[tipo]) medidaParam = SIZEV[tipo].reduce(function (a, b) { return Math.abs(b - measure) < Math.abs(a - measure) ? b : a; });
      else if (RANGES[tipo]) RANGES[tipo].forEach(function (r, k) { if (measure >= r[0] && measure <= r[1]) medidaParam = k + 1; });
    }
    return { q: q, n: n, tokens: tokens, tipo: tipo, measure: measure, medidaParam: medidaParam };
  }

  function lev1(a, b) { /* distância de edição ≤ 1 */
    if (a === b) return true; var la = a.length, lb = b.length; if (Math.abs(la - lb) > 1) return false;
    if (la === lb) { var k = 0; while (k < la && a[k] === b[k]) k++; if (k < la - 1 && a[k] === b[k + 1] && a[k + 1] === b[k] && a.slice(k + 2) === b.slice(k + 2)) return true; }
    var i = 0, j = 0, d = 0;
    while (i < la && j < lb) { if (a[i] === b[j]) { i++; j++; continue; } if (++d > 1) return false; if (la > lb) i++; else if (lb > la) j++; else { i++; j++; } }
    return d + (la - i) + (lb - j) <= 1;
  }
  function swap1(a, b) { /* duas letras trocadas de lugar (sfoa = sofa) */
    if (a.length !== b.length) return false; var k = 0; while (k < a.length && a[k] === b[k]) k++;
    return k < a.length - 1 && a[k] === b[k + 1] && a[k + 1] === b[k] && a.slice(k + 2) === b.slice(k + 2);
  }
  function tokMatch(tok, words) {
    var alts = SYN[tok] || [tok];
    for (var a = 0; a < alts.length; a++) {
      var t = alts[a];
      for (var w = 0; w < words.length; w++) {
        var wd = words[w];
        if (wd.indexOf(t) === 0 || (t.length >= 4 && wd.indexOf(t) > -1)) return 2;
        if (t.length >= 4 && wd.length >= 4 && (t.length >= 5 ? (lev1(t, wd) || (t.length >= 6 && lev1(t, wd.slice(0, t.length)))) : swap1(t, wd))) return 1;
      }
    }
    return 0;
  }

  /* largura do produto em cm (mesma regra do catálogo) */
  function widths(p) {
    if (p.__w) return p.__w;
    var f = String(p.f || '').split('|'), w = f[0] ? f[0].split(',').map(Number).filter(Boolean) : [];
    if (!w.length && p.m) {
      var m = String(p.m).match(/(?:largura|di[aâ]metro|comprimento)\s*:?\s*(\d+(?:,\d+)?)\s*(m|cm)/i);
      if (m) { var v = parseFloat(m[1].replace(',', '.')); w = [m[2].toLowerCase() === 'm' || v < 10 ? Math.round(v * 100) : Math.round(v)]; }
    }
    return (p.__w = w);
  }
  function typeOk(p, tipo) {
    var t = norm(p.t);
    if (tipo === 'sofas') return /^sofa/.test(t);
    if (tipo === 'poltronas') return /^(poltrona|chaise)/.test(t);
    if (tipo === 'cadeiras') return /^cadeira/.test(t) && !/escritorio|office/.test(t);
    if (tipo === 'banquetas') return /^(banqueta|banco)/.test(t);
    if (tipo === 'mesas-jantar') return /^mesa de jantar/.test(t);
    return true;
  }
  function sizeOk(p, P) {
    if (!P.measure || !P.tipo) return true;
    var w = widths(p); if (!w.length) return false;
    var tol = P.tipo === 'sofas' || P.tipo === 'mesas-jantar' ? Math.max(15, P.measure * 0.08) : 6;
    return w.some(function (x) { return Math.abs(x - P.measure) <= tol; });
  }

  /* busca local nos dados do catálogo (instantânea) */
  function search(q, items) {
    var P = typeof q === 'string' ? parse(q) : q, out = [];
    if (!P.tokens.length && !P.measure) return { P: P, list: [] };
    items.forEach(function (p, idx) {
      if (!p || !p.t || /^manual/i.test(p.t) || !(p.p > 0)) return;
      if (P.tipo && P.measure && !typeOk(p, P.tipo)) return;
      if (!sizeOk(p, P)) return;
      var words = (p.__wd = p.__wd || norm(p.t + ' ' + (p.ty || '')).split(' '));
      var hit = 0, score = 0;
      P.tokens.forEach(function (t) { var s = tokMatch(t, words); if (s) { hit++; score += s; } });
      if (P.tokens.length && hit === 0) return;
      var all = hit === P.tokens.length;
      score += (all ? 10 : 0) + (p.a ? 1 : 0) + (BEST[p.h] ? (BEST[p.h] <= 8 ? 1.5 : 0.5) : 0) + (norm(p.t).indexOf(P.tokens[0] || '~') === 0 ? 2 : 0);
      out.push({ p: p, s: score, all: all, i: idx });
    });
    var full = out.filter(function (x) { return x.all; });
    var list = (full.length ? full : out.filter(function (x) { return x.s >= Math.max(1, P.tokens.length); })).sort(function (a, b) { return b.s - a.s || a.i - b.i; }).map(function (x) { return x.p; });
    return { P: P, list: list };
  }
  function cats(P) {
    if (!P.tokens.length) return [];
    return CATS.map(function (c) {
      var hit = 0; P.tokens.forEach(function (t) { var alts = SYN[t] || [t]; if (c.k.some(function (k) { return alts.some(function (a) { return k.indexOf(a) === 0 || (a.length >= 5 && lev1(a, k)); }); })) hit++; });
      return { c: c, hit: hit };
    }).filter(function (x, i, arr) { return x.hit > 0 && (x.hit === P.tokens.length || !arr.some(function (y) { return y.hit === P.tokens.length; })); }).sort(function (a, b) { return b.hit - a.hit || (b.hit === P.tokens.length) - (a.hit === P.tokens.length) || a.c.n.length - b.c.n.length; }).slice(0, 4).map(function (x) { return x.c; });
  }
  /* palavras que viram filtro do catálogo (ex.: 'sofá 2,80 com chaise' → sofás com chaise de ~2,80 m) */
  var FX = {
    sofas: [[/^(chaise|chaises|canto|l)$/, 'composicao', 'chaise', 'com chaise'], [/^ilha/, 'composicao', 'ilha', 'ilha'], [/^modula/, 'composicao', 'modular', 'modulares'],
      [/^(retrat|reclin)/, 'assento', 'retratil', 'retráteis'], [/^fix/, 'assento', 'fixo', 'fixos'], [/^(organic|curv|redond)/, 'formato', 'organico', 'orgânicos'], [/^capa$/, 'revestimento', 'capa', 'de capa']],
    poltronas: [[/^girat/, 'modelo', 'giratoria', 'giratórias'], [/^(puff|pufe|puf)/, 'modelo', 'puff', 'com puff'], [/^fix/, 'modelo', 'fixa', 'fixas']],
    'mesas-jantar': [[/^redond/, 'formato', 'redonda', 'redondas'], [/^(organic|curv)/, 'formato', 'organica', 'orgânicas'], [/^retangul/, 'formato', 'retangular', 'retangulares'], [/^oval/, 'formato', 'oval', 'ovais']]
  };
  function measureLink(P) {
    if (!P.measure || !P.tipo || !P.medidaParam) return null;
    var fx = FX[P.tipo] || [], qs = '', words = [], used = {};
    for (var i = 0; i < P.tokens.length; i++) {
      var t = P.tokens[i], ok = false;
      if (/^(sofa|poltrona|cadeira|banqueta|banco|mesa|jantar|chaise)/.test(t) && TYPES.some(function (x) { return x[1].test(t); }) && !(P.tipo === 'sofas' && /^chaise/.test(t))) ok = true;
      else if (t === 'jantar' && P.tipo === 'mesas-jantar') ok = true;
      else for (var j = 0; j < fx.length; j++) if (fx[j][0].test(t)) { if (!used[fx[j][1]]) { used[fx[j][1]] = 1; qs += '&f_' + fx[j][1] + '=' + fx[j][2]; words.push(fx[j][2] === 'chaise' ? (/^(canto|l)$/.test(t) ? 'de canto' : 'com chaise') : fx[j][3]); } ok = true; break; }
      if (!ok) return null; /* palavra que o catálogo não sabe filtrar (ex.: nome do modelo): fica só a lista de produtos */
    }
    var label = (TYPE_NAME[P.tipo] || 'Peças') + (words.length ? ' ' + words.join(' ') : '') + (RANGES[P.tipo] ? ' com cerca de ' + fm(P.measure) + ' de largura' : ' com cerca de ' + fm(P.measure));
    return { label: label, url: '/pages/catalogo?tipo=' + P.tipo + qs + '&medida=' + P.medidaParam };
  }

  /* mais vendidos: ordem 'best-selling' do Shopify */
  var bestP = null;
  function best() {
    if (bestP) return bestP;
    try { var c = JSON.parse(sessionStorage.getItem('am-best-v1') || 'null'); if (c && c.t > Date.now() - 36e5) return (bestP = Promise.resolve(c.h)); } catch (e) {}
    return (bestP = fetch('/collections/all?sort_by=best-selling&section_id=am-data&page=1', { credentials: 'same-origin' })
      .then(function (r) { return r.text(); })
      .then(function (t) { var m = t.match(/class="am-data">([\s\S]*?)<\/script>/), h = m ? (JSON.parse(m[1]).scope || []).slice(0, 24) : []; try { sessionStorage.setItem('am-best-v1', JSON.stringify({ t: Date.now(), h: h })); } catch (e) {} return h; })
      .catch(function () { return []; }));
  }
  var BEST = {};
  function isBest(p) { return BEST[p.h] && BEST[p.h] <= 8; }

  window.AttuaSearch = { best: best, parse: parse, search: search, cats: cats, measureLink: measureLink, norm: norm, widths: widths };

  /* ---------- interface ---------- */
  var RKEY = 'am-recent-search';
  function recent() { try { return JSON.parse(localStorage.getItem(RKEY) || '[]').slice(0, 5); } catch (e) { return []; } }
  function remember(q) { q = String(q || '').trim(); if (!q) return; try { var r = recent().filter(function (x) { return norm(x) !== norm(q); }); r.unshift(q); localStorage.setItem(RKEY, JSON.stringify(r.slice(0, 5))); } catch (e) {} }
  var fmt = new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL', maximumFractionDigits: 0 });
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function sUrl(q) { return '/search?q=' + encodeURIComponent(q) + '&options%5Bprefix%5D=last'; }

  var LOGO = 'https://attuadesign.com.br/cdn/shop/files/Attua_Logo_2026_Novo_e_definitivo_-_PNG_x_COR_2c2b2a.png?v=1776873474&width=300';
  var bestDone = false, bestH = [], root, input, body, data = null, timer = null, lastQ = '', reqId = 0, anchor = null;
  function build() {
    if (root) return;
    root = document.createElement('div');
    root.className = 'ams'; root.hidden = true;
    root.innerHTML =
      '<div class="ams__bg" data-close></div>' +
      '<div class="ams__panel" role="dialog" aria-label="Buscar na Attua"><div class="ams__top">' +
        '<a class="ams__logo" href="/" aria-label="Attua Design"><img src="' + LOGO + '" alt="Attua Design" width="120" height="40"></a>' +
        '<form class="ams__bar" action="/search" method="get" role="search">' +
          '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" aria-hidden="true"><circle cx="11" cy="11" r="6.5"/><path d="M20 20l-4.2-4.2"/></svg>' +
          '<input class="ams__input" type="search" name="q" autocomplete="off" placeholder="Buscar sofás, poltronas, mesas… ou uma medida, ex.: sofá 2,40" aria-label="Buscar">' +
          '<input type="hidden" name="options[prefix]" value="last">' +
        '</form>' +
        '<button type="button" class="ams__x" data-close aria-label="Fechar busca"><span>esc</span><svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg></button>' +
      '</div><div class="ams__body" aria-live="polite"></div></div>';
    document.body.appendChild(root);
    input = root.querySelector('.ams__input'); body = root.querySelector('.ams__body');
    root.addEventListener('click', function (e) {
      if (e.target.closest('[data-close]')) { e.preventDefault(); close(); return; }
      var t = e.target.closest('[data-q]'); if (t) { e.preventDefault(); input.value = t.getAttribute('data-q'); input.focus(); run(); return; }
      var a = e.target.closest('a[href]'); if (a) remember(input.value);
    });
    root.querySelector('form').addEventListener('submit', function (e) {
      var q = input.value.trim(); if (!q) { e.preventDefault(); return; }
      remember(q);
      var P = parse(q), ml = measureLink(P);
      if (ml) { e.preventDefault(); location.href = ml.url; }
    });
    input.addEventListener('input', function () { clearTimeout(timer); timer = setTimeout(run, 110); });
    input.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { close(); return; }
      if (e.key !== 'ArrowDown' && e.key !== 'ArrowUp') return;
      var links = [].slice.call(body.querySelectorAll('a, button[data-q]')); if (!links.length) return;
      e.preventDefault(); links[e.key === 'ArrowDown' ? 0 : links.length - 1].focus();
    });
    body.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { close(); input.focus(); return; }
      if (e.key !== 'ArrowDown' && e.key !== 'ArrowUp') return;
      var links = [].slice.call(body.querySelectorAll('a, button[data-q]')), i = links.indexOf(document.activeElement);
      if (i < 0) return; e.preventDefault();
      var n = i + (e.key === 'ArrowDown' ? 1 : -1); if (n < 0) input.focus(); else if (links[n]) links[n].focus();
    });
    window.addEventListener('resize', place);
  }
  function place() {
    if (!root || root.hidden) return;
    var panel = root.querySelector('.ams__panel');
    panel.style.cssText = '';
  }
  function open(trigger) {
    build(); anchor = trigger || null;
    root.hidden = false; document.documentElement.classList.add('ams-open');
    place(); input.value = ''; lastQ = null; run();
    setTimeout(function () { input.focus(); }, 30);
    var need = [];
    if (!data && window.AttuaData) need.push(window.AttuaData().then(function (d) { data = d || []; }));
    if (!bestDone) need.push(best().then(function (h) { h.forEach(function (x, i) { BEST[x] = i + 1; }); bestH = h; bestDone = true; }));
    if (need.length) Promise.all(need).then(function () { if (!root.hidden) { lastQ = null; run(); } });
  }
  function close() { if (!root) return; root.hidden = true; document.documentElement.classList.remove('ams-open'); }

  function chips(list, cls) { return '<div class="ams__chips' + (cls ? ' ' + cls : '') + '">' + list.join('') + '</div>'; }
  function emptyState() {
    var r = recent(), side = '', main = '';
    if (r.length) side += '<p class="ams__t">Buscas recentes</p><div class="ams__links">' + r.map(function (x) { return '<button type="button" class="ams__link ams__link--recent" data-q="' + esc(x) + '"><svg viewBox="0 0 24 24" width="13" height="13" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" aria-hidden="true"><circle cx="12" cy="12" r="8.5"/><path d="M12 7.5V12l3 2"/></svg>' + esc(x) + '</button>'; }).join('') + '</div>';
    side += '<p class="ams__t">Mais buscados</p><div class="ams__links">' + POPULAR.map(function (x) { return '<button type="button" class="ams__link" data-q="' + esc(x) + '">' + esc(x) + '</button>'; }).join('') + '</div>';
    side += '<p class="ams__tip">Busque também pela medida, ex.: <button type="button" class="ams__lnk" data-q="sofá 2,40">sofá 2,40</button> ou <button type="button" class="ams__lnk" data-q="poltrona 80 cm">poltrona 80 cm</button>.</p>';
    main += '<p class="ams__t">Categorias</p>' + chips(MAIN.map(function (x) { return '<a class="ams__chip" href="' + x[1] + '">' + esc(x[0]) + '</a>'; }));
    if (data && bestH.length) {
      var byH = {}; data.forEach(function (p) { byH[p.h] = p; });
      var bl = bestH.map(function (x) { return byH[x]; }).filter(function (p) { return p && p.p > 0 && !/^manual/i.test(p.t); }).slice(0, 4);
      if (bl.length) main += '<p class="ams__t">Mais vendidos</p><div class="ams__cards">' + bl.map(card).join('') + '</div>';
    }
    body.innerHTML = '<div class="ams__cols"><aside class="ams__side">' + side + '</aside><div class="ams__main">' + main + '</div></div>';
  }
  function card(p) {
    var sale = p.c > p.p;
    return '<a class="ams__card" href="/products/' + encodeURIComponent(p.h) + '"><span class="ams__cimg">' + (p.i ? '<img src="' + String(p.i).replace(/width=\d+/, 'width=400') + '" alt="" loading="lazy" width="300" height="300">' : '') + '</span>' +
      '<span class="ams__name">' + esc(p.t) + '</span><span class="ams__price">' + (sale ? '<s>' + fmt.format(p.c) + '</s> ' : '') + '<span' + (sale ? ' class="is-sale"' : '') + '>' + fmt.format(p.p) + '</span></span></a>';
  }
  function row(p) {
    var sale = p.c > p.p, img = String(p.i || '').replace(/width=\d+/, 'width=200');
    return '<a class="ams__item" href="/products/' + encodeURIComponent(p.h) + '">' +
      '<span class="ams__img">' + (img ? '<img src="' + img + '" alt="" loading="lazy" width="64" height="64">' : '') + '</span>' +
      '<span class="ams__info">' + (isBest(p) ? '<span class="ams__badge">Mais vendido</span>' : '') + '<span class="ams__name">' + esc(p.t) + '</span>' +
      '<span class="ams__price">' + (sale ? '<s>' + fmt.format(p.c) + '</s> ' : '') + '<span' + (sale ? ' class="is-sale"' : '') + '>' + fmt.format(p.p) + '</span></span></span>' +
      '</a>';
  }
  function render(q, P, list, extra) {
    var side = '', main = '', ml = measureLink(P), cs = cats(P);
    if (ml) side += '<a class="ams__measure" href="' + ml.url + '"><span class="ams__mi"><svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" aria-hidden="true"><path d="M3 9h18v6H3z"/><path d="M7 9v3M11 9v2M15 9v3M19 9v2"/></svg></span><span><strong>' + esc(ml.label) + '</strong><span>Ver os modelos nessa medida</span></span></a>';
    if (cs.length) side += '<p class="ams__t">Categorias</p><div class="ams__links">' + cs.map(function (c) { return '<a class="ams__link" href="' + c.u + '">' + esc(c.n) + '</a>'; }).join('') + '</div>';
    var all = list.concat((extra || []).filter(function (x) { return list.indexOf(x) < 0; }));
    if (all.length) {
      main += '<p class="ams__t">Produtos</p><div class="ams__list">' + all.slice(0, 6).map(row).join('') + '</div>';
      main += '<div class="ams__more"><a class="ams__all" href="' + sUrl(q) + '">Ver todos os resultados' + (all.length > 6 ? ' <span>(' + all.length + (extra === null ? '+' : '') + ')</span>' : '') + '</a></div>';
    } else if (!ml) {
      main += '<div class="ams__none"><p>Não encontramos peças para “' + esc(q) + '”.</p><p>Tente outra palavra ou fale com uma consultora: muitos modelos são feitos sob medida.</p></div>';
      side += '<p class="ams__t">Mais buscados</p><div class="ams__links">' + POPULAR.map(function (x) { return '<button type="button" class="ams__link" data-q="' + esc(x) + '">' + esc(x) + '</button>'; }).join('') + '</div>';
    }
    body.innerHTML = '<div class="ams__cols' + (side ? '' : ' ams__cols--one') + '"><aside class="ams__side">' + side + '</aside><div class="ams__main">' + main + '</div></div>';
  }
  function run() {
    var q = input.value.trim();
    if (q === lastQ) return; lastQ = q;
    if (q.length < 2) { emptyState(); return; }
    var P = parse(q), items = data || [];
    var res = items.length ? search(P, items).list : [];
    render(q, P, res, items.length ? null : []);
    /* completa com a busca do Shopify (pega descrição e etiquetas) */
    var id = ++reqId;
    fetch('/search/suggest.json?q=' + encodeURIComponent(q.replace(/\d+[.,]?\d*\s*(cm|m)?/g, ' ').trim() || q) + '&resources[type]=product&resources[limit]=10&resources[options][unavailable_products]=last', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (j) {
        if (id !== reqId || root.hidden) return;
        var prods = (j.resources && j.resources.results && j.resources.results.products) || [], byH = {};
        items.forEach(function (p) { byH[p.h] = p; });
        var extra = prods.map(function (sp) {
          var p = byH[sp.handle];
          if (!p) p = { h: sp.handle, t: sp.title, p: Math.round(parseFloat(sp.price) || 0), c: Math.round(parseFloat(sp.compare_at_price_max) || 0), i: sp.featured_image && sp.featured_image.url ? sp.featured_image.url + (sp.featured_image.url.indexOf('?') > -1 ? '&' : '?') + 'width=160' : sp.image, a: sp.available ? 1 : 0 };
          return p;
        }).filter(function (p) { return p && p.p > 0 && !/^manual/i.test(p.t) && (!P.measure || !P.tipo || (typeOk(p, P.tipo) && sizeOk(p, P))); });
        if (P.measure && P.tipo) extra = extra.filter(function (p) { return res.indexOf(p) < 0 && byH[p.h]; });
        /* se a busca local já achou peças, o Shopify só completa com o que tem todas as palavras no nome */
        if (res.length) extra = extra.filter(function (p) { var wd = norm(p.t + ' ' + (p.ty || '')).split(' '); return P.tokens.every(function (t) { return tokMatch(t, wd); }); });
        render(q, P, res, extra);
      }).catch(function () {});
  }

  document.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('.am-search-trigger, [data-am-search]');
    if (!t) return;
    e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation();
    open(t);
  }, true);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && root && !root.hidden) { close(); return; }
    if (e.key === '/' && !/input|textarea|select/i.test((document.activeElement || {}).tagName || '') && !(document.activeElement || {}).isContentEditable) { e.preventDefault(); open(document.querySelector('.am-search-trigger')); }
  });
  window.addEventListener('pageshow', function (e) { if (e.persisted) close(); });
})();
